import { FC } from "react";

const retry = (fn: () => Promise<any>, retriesLeft: number = 5, interval: number = 2000): Promise<{ default: FC<any>; }> => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export default retry;